<template>
  <layout>
    <Title
      title="Códigos de Benefícios Fiscais"
      margin="large"
      :hasPrint="true"
      :hasNewRegister="true"
      :routeNewRegister="handleNavigationRegister"
      :newRegisterButtonName="'Novo Código'"
    />
    <Table
      :onClickRow="handleNavigationEdit"
      :tableData="tableData"
      :items="beneficios"
      :pagination="true"
      :rowVariant="false"
      :onSearch="getBeneficio"
    >
    </Table>
  </layout>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { CST } from '@/modules/Fiscal/enums/Beneficio';

import { Layout, Title, Table, TableData, Actions } from '@/components';

export default {
  name: 'BeneficioFiscal',
  components: {
    Layout,
    Title,
    Table,
  },
  props: {
    confirm: {
      type: Function,
    },
  },

  async mounted() {
    await this.resetBeneficioState();
    await this.getBeneficios();
  },
  computed: {
    ...mapState('beneficio', ['beneficios', 'beneficio', 'beneficioCollection']),
    ...mapState('client', ['client']),
    tableData() {
      const { Data, TABLE_CELL_ALIGN } = TableData;

      const DataTable = new Data({
        select: true,
        panelActions: true,
        advancedFilters: true,
        titleMobile: (item) => item.description,
        onSearch: this.getBeneficios,
      });

      DataTable.addField({
        key: 'descricao',
        label: 'Código',
        sortable: true,
        align: TABLE_CELL_ALIGN.center,
        width: 150,
        formatter: (value) => (value === '00000000' ? 'SEM CBENEF' : value),
      })
        .addField({
          key: 'CST00',
          label: 'CST 00',
          formatter: (value) => CST[value],
          align: TABLE_CELL_ALIGN.center,
        })
        .addField({
          key: 'CST02',
          label: 'CST 02',
          formatter: (value) => CST[value],
          align: TABLE_CELL_ALIGN.center,
        })
        .addField({
          key: 'CST10',
          label: 'CST 10',
          formatter: (value) => CST[value],
          align: TABLE_CELL_ALIGN.center,
        })
        .addField({
          key: 'CST15',
          label: 'CST 15',
          formatter: (value) => CST[value],
          align: TABLE_CELL_ALIGN.center,
        })
        .addField({
          key: 'CST20',
          label: 'CST 20',
          formatter: (value) => CST[value],
          align: TABLE_CELL_ALIGN.center,
        })
        .addField({
          key: 'CST30',
          label: 'CST 30',
          formatter: (value) => CST[value],
          align: TABLE_CELL_ALIGN.center,
        })
        .addField({
          key: 'CST40',
          label: 'CST 40',
          formatter: (value) => CST[value],
          align: TABLE_CELL_ALIGN.center,
        })
        .addField({
          key: 'CST41',
          label: 'CST 41',
          formatter: (value) => CST[value],
          align: TABLE_CELL_ALIGN.center,
        })
        .addField({
          key: 'CST50',
          label: 'CST 50',
          formatter: (value) => CST[value],
          align: TABLE_CELL_ALIGN.center,
        })
        .addField({
          key: 'CST51',
          label: 'CST 51',
          formatter: (value) => CST[value],
          align: TABLE_CELL_ALIGN.center,
        })
        .addField({
          key: 'CST53',
          label: 'CST 53',
          formatter: (value) => CST[value],
          align: TABLE_CELL_ALIGN.center,
        })
        .addField({
          key: 'CST60',
          label: 'CST 60',
          formatter: (value) => CST[value],
          align: TABLE_CELL_ALIGN.center,
        })
        .addField({
          key: 'CST61',
          label: 'CST 61',
          formatter: (value) => CST[value],
          align: TABLE_CELL_ALIGN.center,
        })
        .addField({
          key: 'CST70',
          label: 'CST 70',
          formatter: (value) => CST[value],
          align: TABLE_CELL_ALIGN.center,
        })
        .addField({
          key: 'CST90',
          label: 'CST 90',
          formatter: (value) => CST[value],
          align: TABLE_CELL_ALIGN.center,
        })
        .addField({
          key: 'aliqCredPresumido',
          label: '% Alíq cred presumido',
          align: TABLE_CELL_ALIGN.center,
          formatter: (value) =>
            new Intl.NumberFormat('pt-BR', {
              style: 'decimal',
              minimumFractionDigits: 4,
            }).format(value),
        })
        .addActions(Actions('delete', (selected) => this.delete(selected)));
      return DataTable;
    },
  },
  methods: {
    ...mapActions('client', ['setClient']),
    ...mapActions('application', ['setLoading']),
    ...mapActions('beneficio', [
      'saveBeneficio',
      'getBeneficio',
      'getBeneficioId',
      'deleteBeneficio',
      'setBeneficio',
      'resetBeneficioState',
    ]),
    async delete(ids) {
      const form = {
        benefIds: ids.reduce((all, { id }) => (id ? [...all, id] : all), []),
      };
      return this.confirm({
        title: 'Remover Código Benefício',
        message: 'Deseja realmente remover?',
        open: true,
        onOk: async () => {
          try {
            await this.deleteBeneficio(form);
            await this.getBeneficios();
            this.$alert.success('Removido com sucesso!');
            this.setLoading(true);
          } catch (e) {
            this.$alert.error(e?.response?.data?.error_message);
          }
          this.setLoading(false);
        },
      });
    },
    async handleNavigationEdit(item) {
      if (!item.id) return null;

      return this.$router.push({
        name: 'BeneficioFiscalEdit',
        params: { id: item.id },
      });
    },
    async getBeneficios(value) {
      this.setLoading(true);
      try {
        await this.getBeneficio({ search: value });
      } catch (e) {
        this.$alert.error(
          e?.response?.data?.error_message || 'Erro ao carregar Benefícios Fiscais',
        );
      } finally {
        this.setLoading(false);
      }
    },
    async handleNavigationRegister() {
      return this.$router.push({ name: 'BeneficioFiscalRegister' });
    },
  },
};
</script>
